import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginFormData } from '../forms.types';
import logo from '../../media/logo.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import styles from './login.module.css';

type LoginUiProps = {
  formData: LoginFormData;
  error: string;
  loading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

function LoginUi(props: LoginUiProps) {
  const {
    formData,
    error,
    loading,
    onChange,
    onSubmit,
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(-1);
  };

  return (
    <div className={styles.wrapper}>
      <img
        src={logo}
        alt="Foundermatcha Logo"
        className={styles.logo}
      />
      <h2 className={styles.title}>Log In to Your Account</h2>

      <form onSubmit={onSubmit} className={styles.form}>
        <div className={styles.formField}>
          <label htmlFor="email" className={styles.label}>
            Your Email: *
          </label>
          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            onChange={onChange}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.formField}>
          <label htmlFor="password" className={styles.label}>
            Your Password: *
          </label>
          <div className={styles.passwordContainer}>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              value={formData.password}
              onChange={onChange}
              required
              className={styles.input}
            />
            <button
              type="button"
              className={styles.passwordToggle}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword
                ? <VisibilityOffIcon fontSize="small" style={{ color: 'var(--primary-color)' }} />
                : <VisibilityIcon fontSize="small" style={{ color: 'var(--primary-color)' }} />
              }
            </button>
          </div>
        </div>

        <div className={styles.errorContainer}>
          {error && (
            <div className={styles.error}>{error}</div>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          className={styles.submitButton}
        >
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </form>

      <div className={styles.message}>
        <p className={styles.messageText}>
          Don't have an account?{' '}
          <Link to="/signup" className={styles.messageLink}>Sign up here</Link>
        </p>
        <button
          onClick={handleBackToHome}
          className={styles.backLink}
          type="button"
        >
          ← Back to Home
        </button>
      </div>
    </div>
  );
}

export default LoginUi;
